export default "__VITE_ASSET__pDoQmyPo__"